import type { RouteObject } from "react-router";
import { useNavigate } from "react-router";

import { Button, ButtonStyle, PageHeading } from "@prequel/shared-components";

import SourceDetails from "./SourceDetails";
import SourceForm from "./SourceForm";
import SourcePage, { SourceDetailsPage, useSourceContext } from "./SourcePage";
import SourcesTable from "./SourcesTable";

import Breadcrumbs from "@/components/Breadcrumbs";

const SourcesListLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Sources" breadcrumbs={<Breadcrumbs />}>
          <Button text="Add Source" onClick={() => navigate("/import/sources/new")} type={ButtonStyle.SECONDARY} />
        </PageHeading>
        <SourcesTable />
      </div>
    </div>
  );
};

const SourceFormNewLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-3xl px-7 py-4">
        <PageHeading title="Add Source" onGoBack={() => navigate("/import/sources")} breadcrumbs={<Breadcrumbs />} />
        <SourceForm />
      </div>
    </div>
  );
};

const SourceFormEditLayout = () => {
  const navigate = useNavigate();
  const { source, refreshSource } = useSourceContext();

  return (
    <div className="h-full flex-col">
      <div className="max-w-3xl px-7 py-4">
        <PageHeading
          title="Edit Source"
          onGoBack={() => navigate(`/import/sources/${source.id}`)}
          breadcrumbs={<Breadcrumbs dynamicLabel={source.name} />}
        />
        <SourceForm
          sourceId={source.id}
          source={source}
          cancelPath={`/import/sources/${source.id}`}
          onSaved={refreshSource}
        />
      </div>
    </div>
  );
};

export const sourcesRouteChildren: RouteObject = {
  path: "sources",
  handle: {
    breadcrumb: () => ({ label: "Sources" }),
  },
  children: [
    {
      index: true,
      element: <SourcesListLayout />,
    },
    {
      path: "new",
      handle: {
        breadcrumb: () => ({ label: "Add Source" }),
      },
      element: <SourceFormNewLayout />,
    },
    {
      path: ":sourceID",
      handle: {
        breadcrumb: () => ({
          label: "Source Details",
          dynamic: true,
        }),
      },
      element: <SourcePage />,
      children: [
        {
          path: "edit",
          handle: {
            breadcrumb: () => ({ label: "Edit Source" }),
          },
          element: <SourceFormEditLayout />,
        },
        {
          element: <SourceDetailsPage />,
          children: [
            {
              index: true,
              element: <SourceDetails />,
            },
          ],
        },
      ],
    },
  ],
};
